import { render, staticRenderFns } from "./DynComponent.vue?vue&type=template&id=0e53fa3e&"
import script from "./DynComponent.vue?vue&type=script&lang=ts&"
export * from "./DynComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports